/**
 * Portal-local create/update schemas for the Role admin forms.
 *
 * The shared package ships the `Role` type + the `ROLES` name enum but no
 * create/update Role schemas (roles are a fixed governance taxonomy, not a
 * normal CRUD entity — `02 section 3.5`). Rather than touch `packages/shared`, the
 * Role module defines its own thin Zod schemas here, built on the shared `ROLES`
 * tuple, so the create/edit forms get the same RHF + zod validation as every
 * other resource.
 */
import { z } from "zod";
import { ROLES } from "@aos/shared";

export const createRoleSchema = z.object({
  name: z.enum(ROLES),
  description: z.string().nullable().optional(),
});
export const updateRoleSchema = createRoleSchema.partial();

export type CreateRoleInput = z.infer<typeof createRoleSchema>;
export type UpdateRoleInput = z.infer<typeof updateRoleSchema>;
